var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import * as classNames from 'classnames';
import { Avatar, Icon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './Notifications.style';
import TaskTypes from 'src/enums/TaskTypes';
import { isLPUser } from 'src/utils/common';
import { getInitials } from 'src/utils/common';
import Message from 'src/components/reusable/Message';
import taskTypeToIconMap from 'src/maps/taskTypeToIconMap';
import taskTypeToIntMap from 'src/maps/taskTypeToIntlMap';
import { getNotifications } from 'src/auth/cognito/organizationApi';
import NoNotificationsCard from 'src/components/reusable/NoNotificationsCard';
//@ts-ignore
var Notifications = /** @class */ (function (_super) {
    __extends(Notifications, _super);
    function Notifications() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Notifications.prototype.componentDidMount = function () {
        var notifications = this.props.notifications;
        var unseenNotificationsCount = notifications
            .filter(function (notification) { return !notification.isSeen; })
            .map(function (notification) { return notification.id; });
        if (!!unseenNotificationsCount) {
            //  Mark the observations as seen when the component unmounts
            this.props.updateSeenStatus();
        }
    };
    Notifications.prototype.componentWillUnmount = function () {
        var notifications = this.props.notifications;
        var unseenNotificationsCount = notifications
            .filter(function (notification) { return !notification.isSeen; })
            .map(function (notification) { return notification.id; });
        if (!!unseenNotificationsCount) {
            // Refetch notifications on unmount.
            getNotifications();
        }
    };
    Notifications.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, history = _a.history, channels = _a.channels, isLPUser = _a.isLPUser, translate = _a.translate, tubeColor = _a.tubeColor, notifications = _a.notifications, updateIsOpenedStatus = _a.updateIsOpenedStatus;
        return (React.createElement("div", { className: classes.notificationContainer },
            React.createElement("div", { className: classes.headerContainer },
                React.createElement("h2", { className: classes.notificationText }, translate('notifications')),
                isLPUser && React.createElement(Icon, { className: classes.settingsIcon }, "settings")),
            !notifications.length ? (React.createElement("div", { className: classes.nonotificationContainer },
                React.createElement(NoNotificationsCard, { translate: translate }))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.bodyContainer },
                    React.createElement("div", { style: { color: tubeColor }, className: 'px-8 py-8' }, translate('new')),
                    notifications.map(function (notification) {
                        var notificationChannel = (channels || []).find(function (channel) { return channel.id === notification.channelId; });
                        var createdAtDate = moment(new Date(notification.createdAt)).fromNow();
                        return (React.createElement("div", { className: classNames(classes.notification, !notification.isSeen ? classes.unseenNotification : '', 'pl-10'), key: notification.id, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (notification.type === TaskTypes.WATCH_VIDEO) {
                                                history.push("/video/" + notification.videoId);
                                            }
                                            return [4 /*yield*/, updateIsOpenedStatus(notification.id)];
                                        case 1:
                                            _a.sent();
                                            getNotifications();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } },
                            React.createElement("div", { className: "flex w-full" },
                                React.createElement("div", { className: "flex ml-10 pl-10" },
                                    React.createElement("div", { className: "m-auto" },
                                        notificationChannel && notificationChannel.channelIcon ? (React.createElement(Avatar, { className: classes.channelImg, alt: notificationChannel.name, src: notificationChannel.channelIcon })) : (React.createElement(Avatar, { className: classes.channelImg }, getInitials(notificationChannel ? notificationChannel.name : ''))),
                                        React.createElement("div", { className: classes.notificationBadgeWrapper, title: translate(taskTypeToIntMap[notification.type]) },
                                            React.createElement(Icon, { style: { color: 'white', fontSize: 14, marginTop: 3, marginLeft: 3 } }, taskTypeToIconMap[notification.type])))),
                                React.createElement("div", { className: "flex w-full" },
                                    React.createElement("div", { className: classes.notificationBodyText },
                                        React.createElement("div", { className: classes.notificationAbstract },
                                            React.createElement(Message, { html: notification.title })),
                                        notification.isRecommendation && (React.createElement("div", { style: { fontSize: 11, color: 'gray' } },
                                            React.createElement("div", { title: notification.videoAbstract }, notification.videoAbstract))),
                                        React.createElement("div", { className: classes.notificationTimer, style: {
                                                color: !notification.isOpened ? tubeColor : '',
                                            } }, createdAtDate))))));
                    }),
                    React.createElement("div", { className: classes.footerContainer },
                        React.createElement("button", { onClick: function () { return history.push("/notifications"); }, style: { color: tubeColor }, className: classes.seeAllText }, translate('see-all'))))))));
    };
    Notifications = __decorate([
        withStyles(styles)
    ], Notifications);
    return Notifications;
}(React.Component));
var mapStateToProps = function (state) { return ({
    isLPUser: isLPUser(state.auth.user.email),
}); };
export default connect(mapStateToProps, null)(Notifications);



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/Notifications.tsx
// module id = 2037
// module chunks = 81